import { createContext } from "react";

export const NavButtonClosed = createContext({
  isNavClosed: false,
  setIsNevClose: () => {},
});
